import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import CedEst from './components/CedEst';
import GenCedEst from './components/GenCedEst';

function App() {
  return (
   <div id='capapp' className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route exact path="/">
            <CedEst />
          </Route>
          <Route exact path="/ced/:cve/:ciclo" 
            render={(props) => ( <GenCedEst cvect={props.match.params.cve} ciclo={props.match.params.ciclo}/> )} />
        </Switch>
      </Router>
    </div>
  );
}
export default App;